export default {"src":"/_next/static/media/agent-wave.6b12da21.svg","height":70,"width":92,"blurWidth":0,"blurHeight":0};